import { create } from 'zustand';

interface UserProfile {
  id: string;
  email: string;
  name: string;
  phone?: string;
  gender?: string;
  avatar?: string;
  dateOfBirth?: Date | string;
  roles?: (string | { role: { name: string } })[];
}

interface AuthState {
  token: string | null;
  user: UserProfile | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: UserProfile) => void;
  setTokens: (token: string) => void;
  logout: () => void;
}

const safeGetStorage = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeGetUser = (): UserProfile | null => {
  try {
    const raw = localStorage.getItem('admin_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const useAuthStore = create<AuthState>(set => ({
  token: safeGetStorage('admin_token'),
  user: safeGetUser(),
  isAuthenticated: Boolean(safeGetStorage('admin_token')),
  setAuth: (token, user) => {
    try {
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_user', JSON.stringify(user));
      localStorage.removeItem('admin_refresh_token');
    } catch {
      // ignore
    }
    set({
      token,
      user,
      isAuthenticated: true,
    });
  },
  setTokens: token => {
    try {
      localStorage.setItem('admin_token', token);
      localStorage.removeItem('admin_refresh_token');
    } catch {
      // ignore
    }
    set({ token });
  },
  logout: () => {
    try {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_refresh_token');
      localStorage.removeItem('admin_user');
    } catch {
      // ignore
    }
    set({ token: null, user: null, isAuthenticated: false });
  },
}));
